import { create, useStore } from "zustand";
import {INew} from "./types";

export interface INewsStore {
  news: INew[];
  isAddLoading: boolean;
  page: number;
  hasMore: boolean;
  newToEdit: INew | null;
  setNews: (dApps: INew[]) => void;
  addNews: (dApps: INew[]) => void;
  setPage: (page: number) => void;
  setHasMore: (hasMore: boolean) => void;
  setNewEdit: (dAppForEdit: INew | null) => void,
}

export const newsStore = create<INewsStore>((set) => ({
  news: [],
  isAddLoading: false,
  page: 1,
  hasMore: true,
  newToEdit: null,
  setNews: (news) => set({ news }),
  addNews: (news) => set((state) => ({ news: [...state.news, ...news] })),
  setPage: (page) => set({ page }),
  setHasMore: (hasMore) => set({ hasMore }),
  setNewEdit: (newToEdit) => set({ newToEdit }),
}));

export const useNewsStore = () => useStore(newsStore);
